import * as Mutations from './mutations';

export const HeaderModule = {
    state: {
        toolComponentData: null
    },

    getters: {
        toolComponentLoader: state => state.toolComponentData
            ? () => import(`@/components/controls/heading-tools/${state.toolComponentData.name}`)
            : null,
        toolComponentData: state => state.toolComponentData
    },

    mutations: {
        [Mutations.UPDATE_TOOL_COMPONENT](state, data = null) {
            state.toolComponentData = data;
        }
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/header/header.module.js